/*
  Buchanan Albert header (copied from Daniel And Charles): desktop dropdowns and the phone menu.
  Markup: snippets/ba-header-nav.liquid (desktop) and snippets/ba-header-drawer.liquid (phones).
  Category photos carry data-src / data-srcset only; they load the first time their panel or fold opens.
*/
(function () {
  if (window.baHeaderReady) return;
  window.baHeaderReady = true;

  function loadImages(root) {
    if (!root) return;
    root.querySelectorAll('img[data-src]').forEach(function (img) {
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      img.src = img.dataset.src;
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
    });
  }

  /* ---------------- Tablet and desktop menu ---------------- */
  function setupNav(nav) {
    var items = Array.prototype.slice.call(nav.querySelectorAll('[data-ba-item]'));
    var lastPointer = 'mouse';
    var openTimer = null;
    var closeTimer = null;
    var skipFocusOpen = false;

    function topOf(item) { return item.querySelector('[data-ba-top]'); }
    function panelOf(item) { return item.querySelector('[data-ba-panel]'); }
    function isOpen(item) { return item.classList.contains('is-open'); }

    function close(item) {
      if (!isOpen(item)) return;
      item.classList.remove('is-open');
      topOf(item).setAttribute('aria-expanded', 'false');
    }

    function open(item) {
      items.forEach(function (other) { if (other !== item) close(other); });
      if (isOpen(item)) return;
      loadImages(panelOf(item));
      item.classList.add('is-open');
      topOf(item).setAttribute('aria-expanded', 'true');
    }

    function closeAll() { items.forEach(close); }

    nav.addEventListener('pointerdown', function (e) { lastPointer = e.pointerType || 'mouse'; }, true);

    items.forEach(function (item) {
      var top = topOf(item);

      item.addEventListener('pointerenter', function (e) {
        if (e.pointerType !== 'mouse') return;
        clearTimeout(closeTimer);
        clearTimeout(openTimer);
        var anyOpen = items.some(isOpen);
        openTimer = setTimeout(function () { open(item); }, anyOpen ? 0 : 90);
      });

      item.addEventListener('pointerleave', function (e) {
        if (e.pointerType !== 'mouse') return;
        clearTimeout(openTimer);
        closeTimer = setTimeout(function () { close(item); }, 200);
      });

      top.addEventListener('click', function (e) {
        if (top.tagName === 'BUTTON') {
          e.preventDefault();
          if (isOpen(item)) close(item); else open(item);
          return;
        }
        // A link (Women's, Men's): a mouse click or the Enter key goes to the page.
        // A first tap on a touch screen opens the panel instead; a second tap goes to the page.
        if (e.detail !== 0 && lastPointer !== 'mouse' && !isOpen(item)) {
          e.preventDefault();
          open(item);
        }
      });

      item.addEventListener('focusin', function (e) {
        if (skipFocusOpen) return;
        if (e.target === top && top.matches(':focus-visible') && top.tagName !== 'BUTTON') open(item);
      });

      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) close(item);
      });

      item.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && isOpen(item)) {
          close(item);
          skipFocusOpen = true;
          top.focus();
          skipFocusOpen = false;
        }
      });
    });

    document.addEventListener('pointerdown', function (e) {
      if (!nav.contains(e.target)) closeAll();
    });
    window.addEventListener('pageshow', closeAll);
  }

  /* ---------------- Phone menu ---------------- */
  function setupDrawer(drawer, burger) {
    var html = document.documentElement;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var closeTimer = null;

    function finishClose() {
      clearTimeout(closeTimer);
      drawer.classList.remove('is-open', 'is-closing');
      if (drawer.open) drawer.close();
      html.removeAttribute('scroll-lock');
      burger.setAttribute('aria-expanded', 'false');
    }

    function openDrawer() {
      if (drawer.open) return;
      clearTimeout(closeTimer);
      drawer.classList.remove('is-closing');
      drawer.showModal();
      html.setAttribute('scroll-lock', '');
      burger.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { drawer.classList.add('is-open'); });
      });
    }

    function closeDrawer() {
      if (!drawer.open || drawer.classList.contains('is-closing')) return;
      drawer.classList.remove('is-open');
      drawer.classList.add('is-closing');
      closeTimer = setTimeout(finishClose, reduceMotion.matches ? 0 : 260);
    }

    burger.addEventListener('click', openDrawer);
    drawer.addEventListener('cancel', function (e) { e.preventDefault(); closeDrawer(); });
    drawer.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-ba-close]')) closeDrawer();
    });
    drawer.querySelectorAll('details[data-ba-fold]').forEach(function (fold) {
      fold.addEventListener('toggle', function () { if (fold.open) loadImages(fold); });
    });

    var desktop = window.matchMedia('(min-width: 750px)');
    var onWide = function (e) { if (e.matches && drawer.open) finishClose(); };
    if (desktop.addEventListener) desktop.addEventListener('change', onWide);
    // Coming back to a page from the back button must not show the menu still open
    window.addEventListener('pageshow', function (e) { if (e.persisted && drawer.open) finishClose(); });
  }

  function init() {
    var nav = document.querySelector('[data-ba-nav]');
    if (nav) setupNav(nav);
    var drawer = document.querySelector('[data-ba-drawer]');
    var burger = document.querySelector('[data-ba-burger]');
    if (drawer && burger && typeof drawer.showModal === 'function') setupDrawer(drawer, burger);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
